import InvestorLocationModal from './InvestorLocationModal';
export default InvestorLocationModal;
